import { WorkflowTriggerAction } from "../../../../types/rubric";

// Cross-workflow targets are AUTOFILL-only for now. To enable another
// action, add it here and to cqa-service's matching allowlist only after
// backend persistence/runtime semantics and UI/backend/e2e coverage exist.
const CROSS_WORKFLOW_TARGET_ACTIONS = new Set<WorkflowTriggerAction>([
    WorkflowTriggerAction.AUTOFILL,
]);

export const supportsCrossWorkflowTargets = (
    action: WorkflowTriggerAction | undefined | null,
): boolean => action != null && CROSS_WORKFLOW_TARGET_ACTIONS.has(action);
